<template>
<div class="pt-24">
    <div class="bg-main-black pb-10">
        <div class="w-full text-center pt-8 opacity-25">
            <a href="#" v-scroll-to="'#app'"><img src="./../assets/up-arrow.svg" alt="" class="h-6"></a>
        </div>

        <div class="w-full text-center">
            <div>
                <img src="./../assets/lingua-ai-logo.png" alt="Lingua AI: Учим языки легко" class="h-16 mt-8">
            </div>
            <div class="text-grey-lightest fond-bold text-2xl">
                Lingua AI
            </div>
            
        </div>
        <div class="flex items-start justify-center text-center text-grey-lightest mt-24">
            <div class="md:w-1/3 xs:w-1/2">
                <div class="font-bold text-lg">О приложении</div>
                <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4">
                    <a href="/policy" class="no-underline text-grey-lightest">Политика конфиденциальности</a>
                    <a href="/terms" class="no-underline text-grey-lightest mt-2">Условия использования</a>
                    <a href="/remove-account" class="no-underline text-grey-lightest mt-2">Удаление аккаунта</a>
                </div>
                
            </div>
            <div class="md:w-1/3 xs:w-1/2">
                <div class="font-bold text-lg">Установить из</div>
                <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4">
<!--                    <a href="#" class="no-underline text-grey-lightest">Apple App Store <span class="md:inline-block xs:hidden">(iOS)</span></a>-->
                    <a
                        href="https://play.google.com/store/apps/details?id=ai.lingua.vetrov"
                        class="no-underline text-grey-lightest mt-2"
                        target="_blank"
                    >Google Play Store <span class="md:inline-block xs:hidden">(Android)</span></a>
                </div>
                
            </div>
<!--            <div class="md:w-1/5 xs:w-1/3">
                <div class="font-bold text-lg">Company</div>
                <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4">
                    <a href="#" class="no-underline text-grey-lightest">About Us</a>
                    <a href="#" class="no-underline text-grey-lightest mt-2">Jobs</a>
                    <a href="#" class="no-underline text-grey-lightest mt-2">Sitemap</a>
                </div>
                
            </div>-->
        </div>
<!--        <div class="flex flex-wrap mt-12 items-center justify-between p-3">
            <div class="text-grey-lightest text-sm opacity-75">
                designed and developed by 
                <a href="https://github.com/siokas" class="no-underline text-blue">siokas</a>
            </div>
            <div class="">
                <img src="./../assets/facebook.svg" alt="facebook icon" class="h-6 mr-6">
                <img src="./../assets/twitter.svg" alt="twitter icon" class="h-6 mr-6">
                <img src="./../assets/youtube.svg" alt="youtube icon" class="h-6">
                &lt;!&ndash; <img src="./../assets/google-plus.svg" alt="googleplus icon" class="h-6"> &ndash;&gt;
                &lt;!&ndash; <img src="./../assets/linkedin.svg" alt="" class="h-6 mr-6"> &ndash;&gt;
            </div>

        </div>-->
        
    </div>
</div>
</template>

<script>
export default {

};
</script>